export const ALL_DASHBOARDS_CATEGORY = 'all';
